export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";

export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const LOGOUT_USER_ERROR = "LOGOUT_USER_ERROR";

export const LOGIN_RESET_PASSWORD_USER = "LOGIN_RESET_PASSWORD_USER";
export const LOGIN_RESET_PASSWORD_SUCCESS = "LOGIN_RESET_PASSWORD_SUCCESS";
export const LOGIN_RESET_PASSWORD_ERROR = "LOGIN_RESET_PASSWORD_ERROR";

export const LOGIN_1FA = "LOGIN_1FA";
export const LOGIN_1FA_SUCCESS = "LOGIN_1FA_SUCCESS";
export const LOGIN_1FA_ERROR = "LOGIN_1FA_ERROR";

export const LOGIN_2FA = "LOGIN_2FA";
export const LOGIN_2FA_SUCCESS = "LOGIN_2FA_SUCCESS";
export const LOGIN_2FA_ERROR = "LOGIN_2FA_ERROR";

export const RESEND_OTP = "RESEND_OTP";
export const RESEND_OTP_SUCCESS = "RESEND_OTP_SUCCESS";
export const RESEND_OTP_ERROR = "RESEND_OTP_ERROR";
